import angular from 'angular';

import tszReportActions from './tsz-report-actions';

const tszReportActionsModule = angular.module('tsz.components.tszReportActions', [])
  .component('tszReportActions', tszReportActions);

export default tszReportActionsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-report-actions/tsz-report-actions.module.js